import React, { useState } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { fetchWithAuth } from "../../Context/UserContext";
import API_URL from "../../config";

const InvitarProveedorModal = ({ show, onClose, tenderId }) => {
  const [form, setForm] = useState({
    contacto_nombre: "",
    contacto_telefono: "",
    contacto_email: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [inviteLink, setInviteLink] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleClose = () => {
    setForm({ contacto_nombre: "", contacto_telefono: "", contacto_email: "" });
    setInviteLink(null);
    setError("");
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await fetchWithAuth(`${API_URL}/licit/tender/${tenderId}/invite`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await response.json();

      if (!response.ok) {
        setError(data.error || "Error al crear la invitación. Inténtalo más tarde.");
        return;
      }

      setInviteLink(data.invite_link);
    } catch (err) {
      console.error("Error al crear la invitación:", err);
      setError("Error en la conexión con el servidor. Inténtalo más tarde.");
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(inviteLink);
    toast.success("Link copiado al portapapeles");
  };

  const whatsappHref = inviteLink
    ? `https://api.whatsapp.com/send?${form.contacto_telefono ? `phone=${encodeURIComponent(form.contacto_telefono)}&` : ""}text=${encodeURIComponent(
        `Te invitamos a cotizar en Procu: ${inviteLink}`
      )}`
    : "#";

  return (
    <Dialog open={show} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Invitar proveedor a esta licitación</DialogTitle>
        </DialogHeader>

        {inviteLink ? (
          <div className="space-y-3 text-sm">
            <p className="text-muted-foreground">
              Comparte este link con el proveedor para que se registre y cotice directamente.
            </p>
            <div className="flex items-center gap-2 rounded-md border border-border p-3">
              <p className="flex-1 break-all text-sm">{inviteLink}</p>
              <Button type="button" variant="outline" size="sm" onClick={copyToClipboard}>
                Copiar
              </Button>
            </div>
            <a href={whatsappHref} target="_blank" rel="noopener noreferrer">
              <Button type="button" className="w-full">
                Enviar por WhatsApp
              </Button>
            </a>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <p className="text-sm text-muted-foreground">
              Indica al menos un teléfono o correo del proveedor que quieres invitar.
            </p>
            <div>
              <label htmlFor="contacto_nombre" className="mb-1.5 block text-sm font-medium text-foreground">
                Nombre de contacto (opcional)
              </label>
              <Input
                id="contacto_nombre"
                name="contacto_nombre"
                value={form.contacto_nombre}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="contacto_telefono" className="mb-1.5 block text-sm font-medium text-foreground">
                Teléfono
              </label>
              <Input
                id="contacto_telefono"
                name="contacto_telefono"
                value={form.contacto_telefono}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="contacto_email" className="mb-1.5 block text-sm font-medium text-foreground">
                Correo
              </label>
              <Input
                id="contacto_email"
                name="contacto_email"
                type="email"
                value={form.contacto_email}
                onChange={handleChange}
              />
            </div>
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? "Generando..." : "Generar link de invitación"}
            </Button>
            {error && <p className="text-center text-sm font-semibold text-destructive">{error}</p>}
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default InvitarProveedorModal;
